import Button from "~/v2/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/v2/components/ui/dialog"

type VaasVersionDialogProps = {
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
  open: boolean
  versionLoading?: boolean
}

const VaasVersionDialog = ({
  onConfirm,
  onOpenChange,
  open,
  versionLoading,
}: VaasVersionDialogProps) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogClose />
        <DialogHeader>
          <DialogTitle>Create New VAAS Version</DialogTitle>
          <DialogDescription>
            This creates a new lesson version first, then a new course version.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            disabled={versionLoading}
            onClick={() => onOpenChange(false)}
            variant="outline"
          >
            Cancel
          </Button>
          <Button disabled={versionLoading} onClick={onConfirm}>
            {versionLoading ? "Creating..." : "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default VaasVersionDialog
